import { object, string } from 'zod';

import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';
import { withIsEnabled } from '@occc/validation';

const MAX_LINES = 4;

const checkMaxLineCount = (value: string) => {
  const lineCount = value.split('\n').length;
  return lineCount <= MAX_LINES;
};

const LongPromptSchema = string({ required_error: IS_REQUIRED })
  .min(1, IS_REQUIRED)
  .max(80, 'Long prompt should not exceed 80 characters.')
  .refine(checkMaxLineCount, {
    message: `Maximum ${MAX_LINES} lines are allowed`,
  });

const ShortPromptSchema = string({ required_error: IS_REQUIRED })
  .min(1, IS_REQUIRED)
  .max(32, 'Short prompt should not exceed 32 characters.')
  .refine(checkMaxLineCount, {
    message: `Maximum ${MAX_LINES} lines are allowed`,
  });

const PromptAtPumpEnabledSchema = object({
  longPrompt: LongPromptSchema,
  shortPrompt: ShortPromptSchema,
});
const PromptAtPumpDisabledSchema = object({
  longPrompt: string().optional(),
  shortPrompt: string().optional(),
});

export const PromptAtPumpSchema = withIsEnabled(
  PromptAtPumpEnabledSchema,
  PromptAtPumpDisabledSchema,
);
